import { render, staticRenderFns } from "./ApplianceDetail.vue?vue&type=template&id=8b29fbca"
import script from "./ApplianceDetail.vue?vue&type=script&lang=js"
export * from "./ApplianceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports